import {
  ContactBillingModel,
  ContactInsuranceModel,
  RefundGroupModel,
  UserDetail,
} from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import { i18n } from '@/plugins';
import { AxiosError } from 'axios';
import { zonedTimeToUtc, format } from 'date-fns-tz';
import { PermissionModel } from '../models/auth/permission.model';

class Util {
  public diffDateText(date?: Date): string | undefined {
    const pastDate = refs.moment().diff(date) > 0;

    const a = refs.moment(pastDate ? undefined : date);
    const b = refs.moment(pastDate ? date : undefined);

    const years = a.diff(b, 'year');
    b.add(years, 'years');

    const months = a.diff(b, 'months');
    b.add(months, 'months');

    const days = a.diff(b, 'days');

    return years | months | days
      ? `
      ${pastDate ? 'Há' : 'Em'} 
      ${i18n.tc('texts.years', years, { years })} 
      ${i18n.tc('texts.months', months, { months })} 
      ${i18n.tc('texts.days', days, { days })}
    `
      : undefined;
  }
  public generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  public removeMask(value: string): string {
    return value ? value.replace(/[^a-zA-Z0-9]/g, '') : '';
  }
  public findEmail(contatcs: ContactInsuranceModel[] | ContactBillingModel[]) {
    const email = contatcs
      ? contatcs.find(
          (contact) =>
            refs.enums.ContactType[contact.Type] ==
            refs.enums.ContactType.Email.toString()
        )
      : undefined;
    return email;
  }
  public createMask(value: string | number | undefined, pattern: string) {
    const v = value?.toString();
    let i = 0;
    return v
      ? pattern.replace(/#/g, () => (v[i] == undefined ? '' : v[i++]))
      : value;
  }
  public findPhones(contatcs: ContactInsuranceModel[] | ContactBillingModel[]) {
    const phones = contatcs
      ? contatcs
          .filter(
            (contact) =>
              refs.enums.ContactType[contact.Type] ==
              refs.enums.ContactType.Phone.toString()
          )
          .map((contact) => {
            contact.Value =
              contact.Value.substring(0, 2) == '55'
                ? contact.Value.slice(2)
                : contact.Value;
            return contact.Value.length == 10
              ? this.createMask(contact.Value, '(##) ####-####')
              : this.createMask(contact.Value, '(##) #####-####');
          })
      : undefined;
    return phones?.join(', ');
  }
  public findCellPhones(
    contatcs: ContactInsuranceModel[] | ContactBillingModel[]
  ) {
    const phones = contatcs
      ? contatcs
          .filter(
            (contact) =>
              refs.enums.ContactType[contact.Type] ==
              refs.enums.ContactType.CellPhone.toString()
          )
          .map((contact) => {
            contact.Value =
              contact.Value.substring(0, 2) == '55'
                ? contact.Value.slice(2)
                : contact.Value;
            return this.createMask(contact.Value, '(##) #####-####');
          })
      : undefined;
    return phones?.join(', ');
  }
  public findPhone(contatcs: ContactInsuranceModel[] | ContactBillingModel[]) {
    const phone = contatcs
      ? contatcs.find(
          (contact) =>
            refs.enums.ContactType[contact.Type] ==
            refs.enums.ContactType.Phone.toString()
        )
      : undefined;
    return phone;
  }
  public findCellphone(
    contatcs: ContactInsuranceModel[] | ContactBillingModel[]
  ) {
    const cellphone = contatcs
      ? contatcs.find(
          (contact) =>
            refs.enums.ContactType[contact.Type] ==
            refs.enums.ContactType.CellPhone.toString()
        )
      : undefined;
    return cellphone;
  }
  public showErrors(err: AxiosError) {
    const data = err?.response?.data;
    const logErrors = (errors: object) => {
      const errorList: string[][] = Object.values(errors);
      if (refs._.isArray(errorList))
        errorList.forEach((e: string[]) => {
          if (refs._.isArray(errorList))
            e.forEach((e2) => refs.eventBus.$toast.error(e2));
        });
    };
    const logListErrors = (errorList: PermissionModel[]) => {
      errorList.forEach((e: PermissionModel) => {
        if (e.Code) {
          refs.eventBus.$toast.error(i18n.t(`errors_codes.${e.Code}`));
        }
      });
    };

    if (data?.Errors && refs._.isArray(data?.Errors)) {
      logListErrors(data.Errors);
      return;
    }
    if (data?.Message) {
      refs.eventBus.$toast.error(data.Message);
      return;
    }
    if (data?.errors) {
      logErrors(data.errors);
      return;
    }
    if (data) {
      logErrors(data);
      return;
    }
  }
  public getPtBrDate(parsedDate: string) {
    parsedDate = parsedDate + 'Z';
    const date = new Date(parsedDate);
    const timeZone = 'America/Sao_Paulo';
    const zonedDate = zonedTimeToUtc(date, timeZone);
    const pattern = 'dd/MM/yyyy HH:mm';
    const output = format(zonedDate, pattern, {
      timeZone: 'America/Sao_Paulo',
    });
    return output;
  }
  public getFullName(user: UserDetail): string {
    return (
      (user.FirstName ? user.FirstName + ' ' : '') +
      (user.LastName ? user.LastName : '')
    );
  }
  public concatContractName(refundGroup: RefundGroupModel) {
    if (!refundGroup.Name) return '--';
    if (
      !refundGroup.ContractName ||
      refundGroup.Name == refundGroup.ContractName
    )
      return refundGroup.Name;
    return (
      refundGroup.Name + ' (Contratante: ' + refundGroup.ContractName + ')'
    );
  }
  public maskUuid(unmaskedUuid: string): string {
    if (unmaskedUuid) {
      return unmaskedUuid.replace(
        /(.{8})(.{4})(.{4})(.{4})(.{12})/,
        '$1-$2-$3-$4-$5'
      );
    }
    return '';
  }
  public hasPermission(expression: string): boolean {
    const values: string[] =
      expression.replace(/['"\s]/g, '').match(/([^;]+)/g) || [];
    const permissions: string[] = JSON.parse(
      localStorage.getItem('permissions') ?? '[]'
    );
    if (!values.some((v) => permissions.includes(v))) {
      return false;
    }
    return true;
  }
}

export const util = new Util();
